import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const firebaseConfig = {
    apiKey: 'AIzaSyA7K4JlMipx59ySdp9tlin8renTHDiK2y4',
    authDomain: 'partyliveapp.firebaseapp.com',
    databaseURL: 'https://partyliveapp-default-rtdb.firebaseio.com',
    projectId: 'partyliveapp',
    storageBucket: 'partyliveapp.appspot.com',
    messagingSenderId: '62375163819',
    appId: '1:62375163819:web:10520d35579ece749784ee',
    measurementId: 'G-BCT549J62S',
};

if (firebase.apps.length === 0) {
    firebase.initializeApp(firebaseConfig);
    firebase.firestore().settings({ experimentalForceLongPolling: true });
}
export const db = firebase.firestore();
export const auth = firebase.auth();
export const storage = firebase.storage();

export const isOnboarded = async () => {
    const result = await db.collection('users').doc(auth.currentUser.uid)
        .get()
        .then(doc => {
            return ({ success: true, isOnbordedStripe: doc.data().isOnboardedStripe });
        }).catch(e => {
            return ({ success: false, error: { code: 'Error while retrieving Stripe onboarding status', message: e } });
        });
    return (
        result
    );
};

export const getUser = async (uid) => {
    const result = await db.collection('users').doc(uid ? uid : auth.currentUser.uid)
        .get()
        .then(doc => {
            return ({ success: true, userInfo: doc.data() });
        }).catch(e => {
            return ({ success: false, error: { code: 'Error while retrieving User info', message: e } });
        });
    return (
        result
    );
}

export const deleteVenue = async (venue) => {
    const result = await db.collection('venue').doc(venue.venueId).delete()
        .then(() => {
            db.collection('places').doc(venue.placeId).set(// delete the onwer id from a place
                { owner: null }, { merge: true }
            ).catch(error => { console.error(error) })
        .catch((error) => { console.error(error) });
        });
    return (
        result
    );
}

export const createVenue = async (venue, uid) => {
    const result = await db.collection('venue').doc(venue.venueId).set( venue, { merge: true })
      .then(() => {
            db.collection('places').doc(venue.placeId).set(
              { owner: uid }, { merge: true }
            ).catch(error => { console.error(error) })
          .catch((error) => { console.error(error) });
      });
    return (
      result
    );
  }

export const setVenue = async (venueId, updatedInfo) => {
    const result = await db.collection('venue').doc(venueId).set({
        updatedInfo
    }, { merge: true }).then(() => { return ({ succes: true }) }).catch(error => (console.error(error)))
    return (result)
}

export const getVenuesOfUser = async (ID) => {
    const result = await db.collection('venue').where('owner', '==', ID ? ID : auth.currentUser.uid).get()
        .then(getVenuesRes => {
            if (!getVenuesRes.empty) {
                const venues = [];
                const venuesRaw = getVenuesRes.docs;
                venuesRaw.forEach(venue => {
                    venues.push(venue.data())
                });
                return (venues)
            } else {
                console.error('No matching documents');
            }
        }).catch((error) => {
            console.error('Error getting document:', error);
        });
    return (
        result
    );
}

export const getVenue = async (venueId) => {
    const result = await db.collection('venue').doc(venueId).get()
        .then(getVenueRes => {
            console.log('vvnnhjdf', getVenueRes.data())
            return (getVenueRes.data())
        }).catch((error) => {
            console.error('Error getting venue:', error);
        });
    return (
        result
    );
}

export const getMessages = (conversationID, callback) => {
    // const uid = auth.currentUser?.uid    
    const messages = db.collection('conversations').doc(conversationID).collection('messages').orderBy("date").onSnapshot((snapshot) => {
        const arr = [];
        snapshot.forEach((doc) => {
        const messData = doc.data();
        // check if message is read and set read status
        // if (messData.read === false && messData.from !== uid) {
        //     setReadStatus(conversationID, doc.id); // set message as read
        //     messData.read = true;
        // }
      arr.push(messData);
    });
    callback(arr);
    }, (error) => {
        console.error("Error getting messages: ", error);
        throw error;
    });
    return messages;    
}

// const setReadStatus = (conversationID, messageID) => {
//     db.collection('conversations').doc(conversationID).collection('messages').doc(messageID).update({ read: true })
//     .then(() => {
//       console.log("Message set as read");
//     })
//     .catch((error) => {
//       console.error("Error setting message as read: ", error);
//       throw error;
//     });
//   }

export const getStripeAccountID = async (ID) => {
    const result = await db.collection('users').doc(ID ? ID : auth.currentUser.uid)
        .get()
        .then(doc => {
            console.log('doc', doc.data())
            return ({ success: true, stripeAccountID: doc.data().stripeAccountID });
        }).catch(e => {
            return ({ success: false, error: { code: 'Error while retrieving Stripe Account ID', message: e },  } );
        });
    return ( 
        result
    );
};

export const setStripeAccount = async (stripeAccountID) => {
    console.log('uid:', auth.currentUser.uid)
    const result = await db.collection('users').doc(auth.currentUser.uid)
        .set(
            {
                stripeAccountID: stripeAccountID,
            },
            { merge: true }
        ).then(() => {
            return ({ success: true, message: 'Stripe Account ID Recorded' });
        }).catch(e => {
            return ({ success: false, error: { code: 'Error while recording Stripe Account ID', message: e } });
        });
    return (
        result
    );
};

export const getStripeCustomerID = async (ID) => {
    console.log('uid:', auth.currentUser.uid)
    const result = await db.collection('users').doc(ID ? ID : auth.currentUser.uid)
        .get()
        .then(doc => {
            const data = doc.data();
            console.log('data', data.stripeAccountID)
            if (data.stripeCustomerID) {
                return ({ success: true, stripeCustomerID: data.stripeCustomerID }, console.log('did it')) ;
            } else {
                return ({ success: false, error: { code: 'No Stripe customer ID', message: 'The user does not have a customer ID yet' } });
            }
        }).catch(e => {
            return ({ success: false, error: { code: 'Error while retrieving Stripe Account ID', message: e } });
        });
    return (
        result
    );
};

export const setCustomerID = async (customerID) => {
    const result = await db.collection('users').doc(auth.currentUser.uid)
        .set(
            {
                stripeCustomerID: customerID,
            },
            { merge: true }
        ).then(() => {
            return ({ success: true, message: 'Stripe customer ID is recorded' });
        }).catch(e => {
            return ({ success: false, error: { code: 'Error while recording Stripe customer ID', message: e } });
        });
    return (
        result
    );
};

export const setStripeOnboarded = async () => {
    const result = await db.collection('users').doc(auth.currentUser.uid)
        .set(
            {
                isOnbordedStripe: true,
            },
            { merge: true }
        ).then(() => {
            return ({ success: true, message: 'Stripe onboarding status is recorded' });
        }).catch(e => {
            return ({ success: false, error: { code: 'Error while recording Stripe Onboarding Status', message: e } });
        });
    return (
        result
    );
};

export const getAdminRate = async () => {
    const result = await db.collection('globals').doc('adminRate').get().then((data) => {
        if (data.exists) {
            return ({ success: true, adminRate: data.data().value });
        } else {
            return ({ success: false, error: { code: 'Error while retriving the admin rate', message: 'Data does not exist' } });
        }
    }).catch(e => {
        return ({ success: false, error: { code: 'Error while retriving the admin rate', message: e } });
    });
    return (
        result
    );
}
